<template>
  <div class="row col-lg-12" v-if="advancedFilters && showAdvancedFilter">
    <div class="col-lg-4 col-md-4 col-sm-12" v-for="filter in advancedFilters" :key="filter.inputId">
      <b-form-group v-if="!filter.type" label-cols-lg="3" :label-for="filter.inputId" :label="filter.label">
        <b-form-input :id="filter.inputId" type="search" v-model="filters[filter.modelProp]" autocomplete="off" :placeholder="filter.placeholder" trim>
        </b-form-input>
      </b-form-group>
      <b-form-group v-if="filter.type === 'multiselect'" label-cols-lg="3" :label-for="filter.inputId" :label="filter.label">
        <multiselect :id="filter.inputId"
                     v-model="filters[filter.modelProp]"
                     :options="filter.options"
                     :track-by="filter.trackBy"
                     :label="filter.labelProp"
                     :multiple="filter.multiple"
                     :placeholder="filter.placeholder"
                     :select-label="filter.selectLabel"
                     :deselect-label="filter.deselectLabel"
                     :selected-label="filter.selectedLabel"
        ></multiselect>
      </b-form-group>
      <div v-if="filter.type === 'checkbox'" class="form-group form-check">
        <input type="checkbox"
               class="form-check-input"
               :id="filter.inputId"
               v-model="filters[filter.modelProp]"
        >
        <label class="form-check-label" :for="filter.inputId">{{ filter.label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: [
    'advancedFilters',
    'showAdvancedFilter',
    'filters',
  ],
}
</script>